<template>
  <div class="container">
    <div class="flex_space_between search_box">
      <div class="flex_start">
        <div class="flex_start_center mr_24">
          <div class="mr_12">设备CCID：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.ccid" class='input_width_200'></el-input>
          </div>
        </div>
        <div class="flex_start_center mr_24">
          <div class="mr_12">绑定状态：</div>
          <div>
            <el-select v-model="searchForm.bind" class='input_width_200'>
              <el-option value="0" label="全部"></el-option>
              <el-option value="2" label="未绑定"></el-option>
              <el-option value="1" label="已绑定"></el-option>
            </el-select>
          </div>
        </div>
        <div class="custom_btn primary_btn" @click="search">搜索</div>
        <div class="custom_btn warning_btn" @click="reset">重置</div>
      </div>
      <div class="flex_start_center">
        <div class="custom_btn primary_btn" @click="setFacil">设备接收</div>
        <div class="custom_btn primary_btn" @click="setConfig">批量设置预警阈值</div>
        <div class="custom_btn primary_btn" @click="setNotice">预警勿扰设置</div>

        <!-- <el-button type="primary" size="small" @click="setConfig">批量设置预警阈值</el-button> -->
        <!-- <el-button type="primary" size="small" @click="setNotice">预警勿扰设置</el-button> -->
      </div>
    </div>

    <el-table :data="tableData" v-loading="loading" align="center" border>
      <el-table-column prop="bind" label="绑定状态" align="center" width="120">
        <template slot-scope="scope">
          <div class="flex_center_center" v-if="scope.row.bind == 1">
            <img src="@/assets/icon/bind.png" class="table_icon" />
            <div>已绑定</div>
          </div>
          <div class="flex_center_center" v-else>
            <img src="@/assets/icon/unbind.png" class="table_icon" />
            <div>未绑定</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ccid" label="设备CCID号" align="center" width="280"></el-table-column>
      <el-table-column prop="bat" label="设备电量" align="center">
        <template slot-scope="scope">{{ scope.row.bat != null ? scope.row.bat + '%' : "" }}</template>
      </el-table-column>
      <el-table-column prop="bed_number" label="床位号" align="center"></el-table-column>
      <el-table-column prop="name" label="患者姓名" align="center"></el-table-column>
      <el-table-column prop="create_time" label="设备创建时间" align="center">
        <template slot-scope="scope">{{ scope.row.create_time ? $dateFtt.dateFtt('yyyy-MM-dd hh:mm:ss', new
          Date(scope.row.create_time * 1000)) : "" }}</template>
      </el-table-column>
      <el-table-column label="操作" width="400" align="center">
        <template slot-scope="scope">
          <el-button plain type="primary" class="_btn" size="large" @click="searchData(scope.row)">数据查询</el-button>
          <el-button plain type="success" class="_btn" size="large"
            v-if="scope.row.bind == 2 && zone_number == '113300'"
            @click="openBindPaitentDialog(scope.row)">绑定患者</el-button>
          <el-button plain type="danger" class="_btn" size="large"
            v-if="scope.row.bind !== 2 && zone_number == '113300'" @click="unbindDevice(scope.row)">解绑患者</el-button>
          <el-button type="primary" plain class="_btn" size="large" @click="replaceEdit(scope.row)">设备替换</el-button>
          <el-button type="primary" plain class="_btn" size="large"
            @click="facilVisibleEdit(scope.row)">设备转让</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="block" style="text-align: center;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
        :page-sizes="[10, 15, 20, 25]" :page-size="perPage" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>
    <el-dialog :visible.sync="setConfigDialog" title="设置阈值/频率" width="1200px" class="el_dialog">
      <div class="set_config_box">
        <el-form :model="configSetForm" :rules="configSetFormRules" ref="configSetForm" class="config_set_form"
          label-width="180px" label-position="left">
          <div class="config_type_title">心率预警阈值</div>
          <el-form-item prop="high_heartrate_value" label="最高值（bpm）：">
            <el-input class="el_input" placeholder="请输入" v-model="configSetForm.high_heartrate_value"></el-input>
            <span style="margin:0 5px 0 40px;">持续</span>
            <el-select class="el_input" placeholder="请选择" v-model="configSetForm.high_heartrate_time">
              <el-option label="立即" :value="1" v-if="affter == '2'"></el-option>
              <el-option label="10分钟" :value="10"></el-option>
              <el-option label="20分钟" :value="20"></el-option>
              <el-option label="30分钟" :value="30"></el-option>
            </el-select>
            <span style="margin:0 5px">高心率预警</span>
          </el-form-item>
          <el-form-item prop="low_heartrate_value" label="最低值（bpm）：">
            <el-input class="el_input" placeholder="请输入" v-model="configSetForm.low_heartrate_value"></el-input>
            <span style="margin:0 5px 0 40px;">持续</span>
            <el-select class="el_input" placeholder="请选择" v-model="configSetForm.low_heartrate_time">
              <el-option label="立即" :value="1" v-if="affter == '2'"></el-option>
              <el-option label="10分钟" :value="10"></el-option>
              <el-option label="20分钟" :value="20"></el-option>
              <el-option label="30分钟" :value="30"></el-option>
            </el-select>
            <span style="margin:0 5px">低心率预警</span>
          </el-form-item>
          <div class="config_type_title mt_20">血氧预警阈值</div>
          <el-form-item prop="spo2" label="最低值（%）：">
            <el-input class="el_input" placeholder="请输入" v-model="configSetForm.spo2"></el-input>
            <span style="margin:0 5px 0 40px;">持续</span>
            <el-select class="el_input" placeholder="请选择" v-model="configSetForm.low_spo_time">
              <el-option label="立即" :value="1" v-if="affter == '2'"></el-option>
              <el-option label="10分钟" :value="10"></el-option>
              <el-option label="20分钟" :value="20"></el-option>
              <el-option label="30分钟" :value="30"></el-option>
            </el-select>
            <span style="margin:0 5px">低血氧预警</span>
          </el-form-item>
          <div class="config_type_title mt_20">数据频率设置</div>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="ppg" label="采集频率：" label-width="auto">
                <div class="el_input">{{ uploadfrequency }}</div>
                 <!-- <el-input class="el_input" placeholder="请输入" v-model="configSetForm.ppg" disabled></el-input> -->
                 
                <!-- <el-select class="el_input_2" placeholder="请选择" v-model="configSetForm.ppg">
                  <el-option v-for="(item, index) in ppg_list" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="normal_rate" label="上传频率：" label-width="auto">
                <el-select class="el_input_2" placeholder="请选择" v-model="configSetForm.normal_rate"
                  v-if="configSetForm.ppg == 300">
                  <el-option v-for="(item, index) in normal_rate_list_1" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-select class="el_input_2" placeholder="请选择" v-model="configSetForm.normal_rate" v-else>
                  <el-option v-for="(item, index) in normal_rate_list_2" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="config_tips">设置阈值后，{{ configSetForm.ppg / 60 * configSetForm.normal_rate }}分钟后生效</div>
        <!-- <el-button type="info" @click="setConfigDialog = false">取 消</el-button> -->
        <!-- <el-button type="primary" @click="confirmSetConfig">确 定</el-button> -->
        <div class="flex_center_center">
          <div class="custom_btn info_btn" @click="setConfigDialog = false">取 消</div>
          <div class="custom_btn primary_btn" @click="confirmSetConfig">确 定</div>
        </div>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="bindPatientDialog" title="绑定患者" width="830px" class="el_dialog" >
      <div class="dialog_search_box">
        <el-input v-model="dialogSearch" placeholder="请输入姓名/床位号/住院号" style="width:220px;"></el-input>
        <el-button type="primary" size="small" @click="searchPatient">搜索</el-button>
      </div>
      <el-table :data="patientTableData" v-loading="patientLoading" align="center" border>
        <el-table-column prop="name" label="患者姓名" align="center"></el-table-column>
        <el-table-column prop="bed_number" label="床位号" align="center"></el-table-column>
        <el-table-column prop="patient_id" label="住院号" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button plain type="success" size="small" @click="bindPatient(scope.row)">绑定该患者</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="text-align:center;">
        <el-pagination @current-change="handleCurrentChangePatient" :current-page="patient_page" :page-sizes="[5]"
          :page-size="patient_perpage" layout="total, sizes, prev, pager, next, jumper"
          :total="patient_total"></el-pagination>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="eidtdataDialog" title="数据查询" width="1200px" class="el_dialog">
      <div class="editDataTable">
        <div class="dialog_search">
          <el-date-picker v-model="editDataDate" type="date" placeholder="选择日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" :clearable="false" :picker-options="pickerOptions"
            @change="dateChange"></el-date-picker>
        </div>
        <el-table :data="editDialogTableData" height="500" v-loading="searchDialogTableLoading">
          <el-table-column prop="insert_day" label="采集指标" align="center"></el-table-column>
          <el-table-column prop="insert_day" label="采集时分秒" align="center">
            <template slot-scope="scope">{{ $dateFtt.dateFtt('hh:00:00', new Date(scope.row.insert_time *
              1000)) }}</template>
          </el-table-column>
          <el-table-column align="center" prop="heartrate" label="心率采集结果">
            <template slot-scope="scope">
              <div>{{ scope.row.heartrate ? scope.row.heartrate : '--' }}（次/分）</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="spo2" label="血氧采集结果">
            <template slot-scope="scope">
              <div>{{ scope.row.spo2 ? scope.row.spo2 : '--' }} %</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showNoticeConfig" title="预警勿扰设置" width="800px" v-loading="noticeDialogLoading" class="el_dialog" >
      <div class="notice_config_box">
        <el-form :model="noticeConfig" ref="noticeForm" label-width="140px">
          <el-form-item label="勿扰开关" prop="not_disturb_switch">
            <el-switch v-model="noticeConfig.not_disturb_switch">
            </el-switch>
          </el-form-item>
          <el-form-item label="勿扰时间段" prop="not_disturb_time" v-if="noticeConfig.not_disturb_switch"
            :rules="timeRanges">
            <el-time-picker is-range v-model="noticeConfig.not_disturb_time" range-separator="-" value-format="HH:mm:ss"
              start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" :clearable="false"
              :default-value="timepickerDefaultValue">
            </el-time-picker>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <div class="config_tips">开启后时间段内不会再接受体征异常预警</div>
        <div class="flex_center_center">
          <div class="custom_btn info_btn" @click="showNoticeConfig = false">取 消</div>
          <div class="custom_btn primary_btn" @click="confirmSetNoticeConfig">确 定</div>
        </div>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="replaceVisible" v-loading="repLoading" title="设备替换" width="800px" class="el_dialog" >
      <div class="replace_box padding_replace_box" v-if="facilitys.type != 2">
        <div class="replace_title">
          请输入管理员密码，获取该功能权限
        </div>
        <div class="replace_items">
          <!-- 蒙板 -->
          <div class="replace_bg" @click="focu"></div>
          <el-input v-model="pwds[0].num" :ref="`autoFocus0`"
            :class="`replac_input ${facilitys.type == 3 ? 'replac_input_err' : ''} `" @input="pwdInput(0)"
            placeholder="" type="password" :maxlength="1">
          </el-input>
          <el-input v-model="pwds[1].num" :ref="`autoFocus1`"
            :class="`replac_input_l ${facilitys.type == 3 ? 'replac_input_err' : ''}`" @input="pwdInput(1)"
            placeholder="" type="password" :maxlength="1">
          </el-input>
          <el-input v-model="pwds[2].num" :ref="`autoFocus2`"
            :class="`replac_input_l ${facilitys.type == 3 ? 'replac_input_err' : ''} `" @input="pwdInput(2)"
            placeholder="" type="password" :maxlength="1">
          </el-input>
          <el-input v-model="pwds[3].num" :ref="`autoFocus3`"
            :class="`replac_input_l ${facilitys.type == 3 ? 'replac_input_err' : ''} `" @input="pwdInput(3)"
            placeholder="" type="password" :maxlength="1">
          </el-input>
          <el-input v-model="pwds[4].num" :ref="`autoFocus4`"
            :class="`replac_input_l ${facilitys.type == 3 ? 'replac_input_err' : ''} `" @input="pwdInput(4)"
            placeholder="" type="password" :maxlength="1">
          </el-input>
          <el-input v-model="pwds[5].num" :ref="`autoFocus5`"
            :class="`replac_input_l ${facilitys.type == 3 ? 'replac_input_err' : ''} `" @input="pwdInput(5)"
            placeholder="" type="password" :maxlength="1">
          </el-input>
        </div>
        <div class="replace_err" v-if="facilitys.type == 3">
          密码错误，请重新填写
        </div>

      </div>
      <div class="replace_box" v-if="facilitys.type == 2 && facilitys.untieBor == false">
        <div class="replace_box_text">
          <div>当前设备正在使用中</div>
          <div>请前往医护主机进行解绑后再操作</div>
        </div>
      </div>
      <div class="replace_search" v-if="facilitys.type == 2 && facilitys.untieBor == true">
        <el-input placeholder="请输入CCID" @input="replaceInput" style="width: 400px;" prefix-icon="el-icon-search"
          v-model="facilitySearch.search">
        </el-input>
        <div class="replace_search_list">
          <div class="replace_search_list_box" v-for="(val, index) in searchList" :key="index">
            <el-radio v-model="facilitySearch._radio" :label="val.id">{{ val.ccid }}</el-radio>
          </div>
        </div>

      </div>
      <span slot="footer" v-if="facilitys.type == 2 && facilitys.untieBor == true" class="dialog-footer">
        <div class="flex_center_center">
          <div class="custom_btn info_btn" @click="replaceVisible = false">取 消</div>
          <div class="custom_btn primary_btn" @click="device_add">确 定</div>
        </div>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="facilVisible" title="设备接收" width="1200px" class="el_dialog">
      <div class="replace_box" v-if="facilData.length == 0">
        <div class="replace_box_text">
          <div>当前暂无需要接收的设备</div>
        </div>
      </div>
      <div v-else>
        <el-table :data="facilData" v-loading="loading" align="center" border height="460px">
          <el-table-column prop="ccid" label="设备CCID号" align="center"></el-table-column>
          <el-table-column prop="zone_name" label="来源病区" align="center"></el-table-column>
          <el-table-column prop="created_at" label="转让提交时间" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.status | __order }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button plain type="primary" size="small" v-if="scope.row.status == 1"
                @click="sell_update(scope.row.id, 2)">接收</el-button>
              <el-button plain type="danger" size="small" v-if="scope.row.status == 1"
                @click="sell_update(scope.row.id, 3)">拒绝</el-button>
              <div v-if="scope.row.status != 1">
                {{ scope.row.status_at }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block_conten">
          <el-pagination @size-change="facilHandleSizeChange" @current-change="facilHandleCurrentChange"
            :current-page="page" :page-sizes="[5, 10, 15, 20]" :page-size="5"
            layout="total, sizes, prev, pager, next, jumper" :total="facilPages.total"></el-pagination>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="facilVisibleDataBor" v-loading="repLoading" title="设备转让" width="800px" class="el_dialog" >
      <div style="min-height: 150px;">
        <div class="" v-if="facilVisibleData.page_code == 3">
          <div class="replace_search">
            <el-input placeholder="请输入病区名称" @input="facilInput" prefix-icon="el-icon-search"
              v-model="facilitySearch.search">
            </el-input>
            <div style="height: 260px;">
              <el-radio-group v-model="facilitySearch._radio">
                <div class="replace_search_list">
                  <div class="replace_search_list_box" v-for="(val, index) in facilVisibleData.list" :key="index">
                    <el-radio v-model="facilVisibleData.zone_number" :label="val.zone_number">{{ val.name }}</el-radio>
                  </div>
                </div>
              </el-radio-group>
            </div>

          </div>
        </div>
        <div class="replace_box" v-if="facilVisibleData.page_code == 1">
          <div class="replace_box_text">
            <div>当前病区不支持转让</div>
          </div>
        </div>
        <div class="replace_box" v-if="facilVisibleData.page_code == 2">
          <div class="replace_box_text">
            <div>当前设备正在使用中</div>
            <div>请前往医护主机进行解绑后再操作</div>
          </div>
        </div>
        <div class="zr" v-if="facilVisibleData.page_code == 4">
          <div class="zr_box_title">当前设备已提交转让申请</div>
          <div class="zr_box">
            <div class="zr_box_l">
              <div class="zr_box_text">目标病区</div>
              <div class="zr_box_text">提交转让时间</div>
            </div>
            <div class="zr_box_r">
              <div class="zr_box_text">{{ facilVisibleData.list.zone_name
              }}</div>
              <div class="zr_box_text">{{ facilVisibleData.list.created_at }}</div>
            </div>
          </div>
        </div>
        <div class="replace_box" v-if="facilVisibleData.page_code == 5">
          <div class="replace_box_text">
            <div>{{ facilVisibleData.msg }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" v-if="facilVisibleData.page_code == 3" class="dialog-footer">
        <!-- <el-button type="info" @click="facilVisibleDataBor = false">取 消</el-button>
        <el-button type="primary" @click="sell_add">确 定</el-button> -->
        <div class="flex_center_center">
          <div class="custom_btn info_btn" @click="facilVisibleDataBor = false">取 消</div>
          <div class="custom_btn primary_btn" @click="sell_add">确 定</div>
        </div>
      </span>
      <span slot="footer" v-if="facilVisibleData.page_code == 4" class="dialog-footer">
        <!-- <el-button type="info" @click="sell_off"  >取消转让</el-button> -->
        <div class="flex_center_center">
          <div class="custom_btn info_btn" @click="sell_off">取消转让</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const checkLow = (rule, value, callback) => {
  setTimeout(() => {
    if (!Number.isInteger(Number(value))) {
      callback(new Error("请输入范围在30-60之间的整数"));
    } else {
      if (value < 30 || value > 60) {
        callback(new Error("请输入范围在30-60之间的整数"));
      } else {
        callback();
      }
    }
  }, 300);
};
const checkHigh = (rule, value, callback) => {
  setTimeout(() => {
    if (!Number.isInteger(Number(value))) {
      console.log(value);
      callback(new Error("请输入范围在80-160之间的整数"));
    } else {
      if (value < 80 || value > 160) {
        callback(new Error("请输入范围在80-160之间的整数"));
      } else {
        callback();
      }
    }
  }, 300);
};
const checkSpo2 = (rule, value, callback) => {
  setTimeout(() => {
    if (!Number.isInteger(Number(value))) {
      callback(new Error("请输入范围在70-99之间的整数"));
    } else {
      if (value < 70 || value > 99) {
        callback(new Error("请输入范围在70-99之间的整数"));
      } else {
        callback();
      }
    }
  }, 300);
};
let time = null
export default {
  data() {
    return {
      searchForm: {
        ccid: "",
        bind: "0",
      },
      zone_number: "",
      setConfigDialog: false,
      configSetForm: {
        high_heartrate_value: 130,
        high_heartrate_time: 10,
        low_heartrate_value: 40,
        low_heartrate_time: 10,
        spo2: 90,
        low_spo_time: 10,
        ppg: 600,
        normal_rate: 6,
      },
      configSetFormRules: {
        high_heartrate_value: [
          { required: true, message: "请输入心率预警最高值", trigger: "blur" },
          { validator: checkHigh, trigger: "blur" },
        ],
        low_heartrate_value: [
          { required: true, message: "请输入心率预警最低值", trigger: "blur" },
          { validator: checkLow, trigger: "blur" },
        ],
        spo2: [
          { required: true, message: "请输入血氧预警最低值", trigger: "blur" },
          { validator: checkSpo2, trigger: "blur" },
        ],
        ppg: [{ required: true, message: "请选择采集频率", trigger: "blur" }],
        normal_rate: [
          { required: true, message: "请选择上传频率", trigger: "blur" },
        ],
      },
      ppg_list: [
        {
          label: "5分钟",
          value: 300,
        },
        {
          label: "10分钟",
          value: 600,
        },
      ],
      normal_rate_list_1: [
        {
          label: "10分钟",
          value: 2,
        },
        {
          label: "15分钟",
          value: 3,
        },
        {
          label: "20分钟",
          value: 4,
        },
        {
          label: "25分钟",
          value: 5,
        },
        {
          label: "30分钟",
          value: 6,
        },
      ],
      normal_rate_list_2: [
        {
          label: "20分钟",
          value: 2,
        },
        {
          label: "30分钟",
          value: 3,
        },
        {
          label: "40分钟",
          value: 4,
        },
        {
          label: "50分钟",
          value: 5,
        },
        {
          label: "60分钟",
          value: 6,
        },
      ],
      defaultConfigValue: {
        high_heartrate_value: 130,
        high_heartrate_time: 10,
        low_heartrate_value: 40,
        low_heartrate_time: 10,
        spo2: 90,
        low_spo_time: 10,
        ppg: 600,
        normal_rate: 6,
      },
      page: 1,
      perPage: 10,
      total: 0,
      tableData: [],
      loading: false,

      dialogSearch: "",
      bindPatientDialog: false,
      bindDeviceItem: {},
      patientTableData: [],
      patientLoading: false,
      patient_page: 1,
      patient_perpage: 5,
      patient_total: 0,
      eidtdataDialog: false,
      searchDialogTableLoading: false,
      editDialogTableData: [],
      pickerOptions: {
        disabledDate(date) {
          return new Date() < date;
        },
      },
      editDataDate: "",
      noticeConfig: {
        not_disturb_switch: 1,
        not_disturb_time: ['', '']
      },

      noticeBtnLoadng: false,
      showNoticeConfig: false,
      timeRanges: [
        {
          required: true, type: "array", message: '请选择勿扰时间段', trigger: 'blur',
          fields: {
            0: { required: true, message: '请选择勿扰时间段', trigger: 'change', },
            1: { required: true, message: '请选择勿扰时间段', trigger: 'change', },
          }
        },
      ],
      noticeDialogLoading: false,
      timepickerDefaultValue: [],
      replaceVisible: false,
      pwds: [
        { num: '' },
        { num: '' },
        { num: '' },
        { num: '' },
        { num: '' },
        { num: '' },
      ],
      facilitys: {
        pwd: '', // 密码
        adminPwd: '', // 设备正确加密后的密码 先定死968888
        bor: false, // 设备是否解绑
        type: 1, // 密码状态    1：未填完 2：正确 3：错误
        untieBor: false, // 解绑状态
        zone_number: '',
        id: '',
      }, // 设备信息
      facilitySearch: {
        search: '',
        _radio: '',
      },

      facilVisible: false,
      facilPages: {
        page: 1,
        perPage: 5,
        total: 0
      },
      facilData: [
      ],
      facilVisibleData: {
        page_code: '', // 当前病区是否支持转让 1:允许转让  2：不支持转让  3：有权限但正在使用中  4：设备已提交但并未接收，拒绝
        list: [],
        id: '',
      },
      facilVisibleDataBor: false,
      searchList: [],
      repLoading: false,
      affter:''
    };
  },
  filters: {
    __order(value) {
      if (value == 1) {
        return '待接收'
      } else if (value == 2) {
        return '已接收'
      } else if (value == 3) {
        return '已拒绝'
      } else if (value == 4) {
        return '对方已取消'
      } else {
        return ''
      }
    }
  },
  computed:{
      uploadfrequency(){
          let index = this.ppg_list.findIndex(item => item.value == this.configSetForm.ppg);
          if(index>=0){
                  return this.ppg_list[index].label
          }else{
              return "10分钟"
          }
      }
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/login");
    }
    this.affter=localStorage.getItem("affter")
    this.zone_number = localStorage.getItem("zone_number");
    this.fetchData();
    this.facilLits();
    this.timepickerDefaultValue = [
      this.$dateFtt.dateFtt(
        "yyyy-MM-dd 00:00:00",
        new Date()
      ),
      this.$dateFtt.dateFtt(
        "yyyy-MM-dd 23:59:59",
        new Date()
      )
    ]

    window.addEventListener('keydown', this.handleKeyDown);
  },

  methods: {
    //设备替换
    replaceEdit(item) {
      console.log('item', item);

      this.replaceVisible = true;
      this.facilitySearch.search = ''
      this.pwds = [
        { num: '' },
        { num: '' },
        { num: '' },
        { num: '' },
        { num: '' },
        { num: '' },
      ]
      this.facilitys = {
        pwd: '',
        adminPwd: '968888',
        bor: false,
        type: 1,
        untieBor: false,
        zone_number: item.ccid,
        id: item.id,
      }
      this.$nextTick(() => {
        this.$refs['autoFocus0'].focus();
      })

    },
    handleKeyDown(event) {
      if (event.key === 'Backspace' && this.replaceVisible == true) {
        // 处理删除键按下事件
        let number = '';
        let bor = true

        this.pwds.map((res, key) => {
          if (res.num == '' && bor) {
            number = key;
            bor = false;
            this.$nextTick(() => {
              if (number > 0) {
                this.$refs[`autoFocus${number - 1}`].focus();
              }

            })
          }
        })
      }
    },
    pwdInput(number) {
      this.$nextTick(() => {
        if (this.pwds[number].num) {
          if (number < 5) {
            this.$refs[`autoFocus${number + 1}`].focus();
          }
          if (this.pwds[5].num) {
            this.repLoading = true
            //输入6位提交 
            this.facilitys.pwd = '';
            this.facilitys.type = 1;
            this.pwds.forEach(res => {
              this.facilitys.pwd += res.num
            })

            let data = {
              zone_number: this.zone_number,
              password: this.facilitys.pwd,
              id: this.facilitys.id,
            }
            console.log(' this.$cookies', localStorage.getItem("token"))
            this.$http({
              url: "/api/device/change_login",
              method: "POST",
              data: data,
              headers: {
                Token: localStorage.getItem("token"),
              },
            }).then((res) => {
              // console.log('res',decodeURI(''))
              // 设备解绑状态
              if (res.message == '密码正确') {
                console.log('密码正确', this.facilitys.pwd)
                this.$message.success('登录成功')
                this.facilitys.type = 2;
                this.facilitys.untieBor = true;
                this.facilitys.adminPwd = res.result.password;
                this.change_list({
                  password: this.facilitys.adminPwd,
                  ccid: '',
                  zone_number: this.zone_number,
                })
              } else if (res.message == '当前设备正在使用中，请前往医护主机进行解绑后再操作') {
                this.facilitys.type = 2;
                this.facilitys.untieBor = false;
              } else {
                this.facilitys.untieBor = false;
                console.log('密码错误', this.facilitys.pwd)
                this.facilitys.type = 3
              }
              this.repLoading = false
            }).catch(err => {
              this.replaceVisible = false;
              this.repLoading = false
            })
          }
        }
      })
    },
    focu() {
      let number = '';
      let bor = true
      if (this.facilitys.type == 3) {
        this.$nextTick(() => {
          this.$refs[`autoFocus${5}`].focus();
        })
      }
      this.pwds.forEach((res, key) => {
        if (res.num == '' && bor) {
          number = key;
          bor = false;
          this.$nextTick(() => {
            this.$refs[`autoFocus${number}`].focus();
          })
        }
      })
    },
    // 设备列表
    change_list(data) {
      this.repLoading = true;
      this.facilitySearch._radio = '';
      this.$http({
        url: "/api/device/change_list",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.repLoading = false
        this.searchList = res.result
      }).catch(err => {
        this.repLoading = false
        console.log(err);
      })
    },
    replaceInput(value) {
      let data = {
        password: this.facilitys.adminPwd,
        ccid: value,
        zone_number: this.zone_number,
      }
      if (time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        this.change_list(data)
        time = null;
      }, 500);
    },
    facilInput(value) {
      let data = {
        zone_number: this.zone_number,
        id: this.facilVisibleData.id,
        name: value,
      }
      if (time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        this.repLoading = true;
        this.$http({
          url: "/api/device/sell_list",
          method: "GET",
          params: data,
          headers: {
            Token: localStorage.getItem("token"),
          },
        }).then((res) => {
          console.log('res', res)
          this.facilVisibleData.page_code = res.result.page_code;
          this.facilVisibleData.list = res.result.date
            ;
          this.repLoading = false;
        }).catch(err => {

        })
        time = null;
      }, 500);
    },
    device_add() {
      console.log(this.facilitySearch._radio)
      if (!this.facilitySearch._radio) {
        this.$message({
          message: '请选择CCID号',
          type: 'warning'
        });
      } else {
        let data = {
          password: this.facilitys.adminPwd,
          id: this.facilitys.id,
          zone_number: this.zone_number,
          change_device_list: this.facilitySearch._radio,
        }
        console.log(data)
        this.$http({
          url: "/api/device/change_update",
          method: "POST",
          params: data,
          headers: {
            Token: localStorage.getItem("token"),
          },
        }).then((res) => {
          this.$message.success('操作成功')
          this.replaceVisible = false
          this.fetchData();
        }).catch(err => {
          this.replaceVisible = false
          this.fetchData();
        })
      }

    },

    // 设备接收
    setFacil() {
      this.facilVisible = true;
      this.facilPages.page = 1;
      this.facilPages.perPage = 5;
      this.facilLits()
    },
    facilLits() {
      let data = {
        zone_number: this.zone_number,
        page: this.facilPages.page,
        perPage: this.facilPages.perPage,
      }
      this.$http({
        url: "/api/device/sell_notice_list",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log('res', res);
        this.facilData = res.result.data
        this.facilPages.total = res.result.total
      }).catch(err => {

      })
    },

    facilHandleSizeChange(e) {
      this.facilPages.page = 1;
      this.facilPages.perPage = e;
      this.facilLits()
    },
    facilHandleCurrentChange(e) {
      this.facilPages.page = e;
      this.facilLits()
    },

    // 设备转让
    facilVisibleEdit(item) {
      console.log(item)
      this.facilVisibleDataBor = true;
      this.facilitySearch.search = ''
      this.repLoading = true;
      this.facilVisibleData = {
        page_code: '', // 当前病区是否支持转让 1:允许转让  2：不支持转让  3：有权限但正在使用中  4：设备已提交但并未接收，拒绝
        list: [],
        id: item.id,

      }

      let data = {
        zone_number: this.zone_number,
        id: item.id,
        name: '',
      }
      this.$http({
        url: "/api/device/sell_list",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log('res', res)
        this.facilVisibleData.page_code = res.result.page_code;
        this.facilVisibleData.list = res.result.date
          ;
        this.repLoading = false;
      }).catch(err => {

      })
    },


    sell_add() {
      if (!this.facilVisibleData.zone_number) {
        return this.$message({
          message: '请选择',
          type: 'warning'
        });
      }
      let data = {
        change_zone_number: this.facilVisibleData.zone_number,
        id: this.facilVisibleData.id,
        zone_number: this.zone_number
      }
      console.log(data)
      this.repLoading = true;
      this.$http({
        url: "/api/device/sell_add",
        method: "POST",
        data: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log('sell_add', res)
        this.facilVisibleData.page_code = 5;
        this.facilVisibleData.msg = res.message
        this.$message.success('操作成功')
        this.repLoading = false;
        this.fetchData();
      }).catch(err => {

      })
    },

    // 取消转让
    sell_off() {
      let data = {
        sell_log_id: this.facilVisibleData.list.sell_log_id,
        zone_number: this.zone_number,
      }
      console.log(data)
      this.$http({
        url: "/api/device/sell_off",
        method: "POST",
        data: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log('res', res)
        this.$message.success('操作成功')
        this.facilVisibleDataBor = false
        this.fetchData();
      }).catch(err => {

      })
    },

    // 接收操作
    sell_update(id, status) {
      let data = {
        zone_number: this.zone_number,
        list_id: id,
        status: status
      }

      this.$http({
        url: "/api/device/sell_update",
        method: "POST",
        data: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log('res', res)
        this.$message.success('操作成功')
        this.facilVisible = false
        this.repLoading = false;
        this.fetchData();
      }).catch(err => {

      })
    },

    confirmSetNoticeConfig() {
      this.$refs['noticeForm'].validate((valid) => {
        if (valid) {
          this.noticeDialogLoading = true
          let data = {
            not_disturb_switch: this.noticeConfig.not_disturb_switch ? 1 : 2,
            zone_number: this.zone_number
          }
          if (data.not_disturb_switch == 1) {
            data.not_disturb_start = this.noticeConfig.not_disturb_time[0]
            data.not_disturb_end = this.noticeConfig.not_disturb_time[1]
          }
          this.$http({
            url: "/api/device/set_not_disturb",
            method: "POST",
            data: data,
            headers: {
              Token: localStorage.getItem("token"),
            },
          }).then((res) => {
            this.showNoticeConfig = false
            this.noticeDialogLoading = false
            this.$message.success('设置成功')
          }).catch(err => {
            this.noticeDialogLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    setNotice() {
      this.noticeBtnLoadng = true
      this.$http({
        url: "/api/device/get_not_disturb",
        method: "GET",
        params: { zone_number: this.zone_number },
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log(this.noticeConfig.not_disturb_time);

        this.noticeConfig.not_disturb_switch = res.result.not_disturb_switch == 1
        this.noticeConfig.not_disturb_time[0] = res.result.not_disturb_start ? res.result.not_disturb_start : ""
        this.noticeConfig.not_disturb_time[1] = res.result.not_disturb_end ? res.result.not_disturb_end : ""
        // this.noticeConfig.not_disturb_end = res.result.not_disturb_end
        // console.log(this.noticeConfig.not_disturb_time);
        this.showNoticeConfig = true
        this.noticeBtnLoadng = false
      }).catch(err => {
        console.log(err);
        this.noticeBtnLoadng = false
      })
    },
    searchData(item) {
      this.eidtdataDialog = true;
      item.end = Number(item.end);
      item.start = Number(item.start);
      if (item.end) {
        this.editDataDate = this.$dateFtt.dateFtt(
          "yyyy-MM-dd",
          new Date(item.end * 1000)
        );
      } else {
        this.editDataDate = this.$dateFtt.dateFtt("yyyy-MM-dd", new Date());
      }
      this.searchDataPatient = item;
      this.fetchSearchDataList();
    },
    fetchSearchDataList() {
      this.searchDialogTableLoading = true;
      let data = {
        ccid: this.searchDataPatient.ccid,
        start: new Date(this.editDataDate + " 00:00:00").getTime() / 1000,
        end: new Date(this.editDataDate + " 23:59:59").getTime() / 1000,
      };
      this.$http({
        url: "api/device/get_msg",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.searchDialogTableLoading = false;
        this.editDialogTableData = res.result;
        this.editDialogTableData.forEach((item, index) => {
          this.editDialogTableData[index].edit_status = false;
        });
        console.log(this.editDialogTableData);
      });
    },
    dateChange(e) {
      console.log(e);
      this.fetchSearchDataList();
    },
    reset() {
      this.searchForm.ccid = "";
      this.searchForm.bind = "0";
      this.page = 1;
      this.fetchData();
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    handleSizeChange(e) {
      this.perPage = e;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchData();
    },
    setConfig() {
      this.setConfigDialog = true;
      this.$http({
        url: "/api/device/get_config",
        method: "GET",
        params: { zone_number: this.zone_number },
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        for (const key in this.configSetForm) {
          if (Object.hasOwnProperty.call(this.configSetForm, key)) {
            this.configSetForm[key] = res.result[key]
              ? res.result[key]
              : this.defaultConfigValue[key];
          }
        }
      });
    },
    confirmSetConfig() {
      this.$refs.configSetForm.validate((valid) => {
        if (valid) {
          let data = Object.assign(
            { zone_number: this.zone_number },
            this.configSetForm
          );
          this.$http({
            url: "/api/device/set_config",
            method: "POST",
            data: data,
            headers: {
              Token: localStorage.getItem("token"),
              // 'Content-Type':"multipart/form-data"
            },
          }).then((res) => {
            this.$message.success("修改成功");
            this.setConfigDialog = false;
          });
        }
      });
    },
    fetchData() {
      this.loading = true;
      let data = {
        page: this.page,
        perPage: this.perPage,
        zone_number: this.zone_number,
        ccid: this.searchForm.ccid,
        bind: this.searchForm.bind,
      };
      if (data.bind == "0") {
        delete data.bind;
      }
      this.$http({
        url: "/api/device/list",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        const result = res.result;
        this.tableData = result.data;

        this.total = result.total;
        this.loading = false;
      });
    },

    openBindPaitentDialog(item) {
      this.bindDeviceItem = item;
      this.bindPatientDialog = true;
      this.fetchPatientData();
    },
    handleCurrentChangePatient(e) {
      this.patient_page = e;
      this.fetchPatientData();
    },
    searchPatient() {
      this.patient_page = 1;
      this.fetchPatientData();
    },
    fetchPatientData() {
      this.patientLoading = true;
      let data = {
        page: this.patient_page,
        perPage: this.patient_perpage,
        zone_number: this.zone_number,
        search: this.dialogSearch,
      };
      this.$http({
        url: "/api/device/patient_list",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.patientTableData = res.result.data;
        this.patientLoading = false;
        this.patient_total = res.result.total;
      });
    },
    bindPatient(item) {
      this.patientLoading = true;
      let data = {
        ccid: this.bindDeviceItem.ccid,
        zone_number: this.zone_number,
        room_number: 9999,
        patient_id: item.patient_id ? item.patient_id : "",
        bed_number: item.bed_number,
        bind: 1,
      };
      this.$http({
        url: "/api/hope/assign_beds",
        method: "POST",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.patientLoading = false;
        this.$message.success("绑定成功");
        this.bindPatientDialog = false;
        this.fetchData();
      });
    },
    unbindDevice(item) {
      this.$confirm("此操作将解绑该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            ccid: item.ccid,
            zone_number: this.zone_number,
            room_number: 9999,
            patient_id: 0,
            bed_number: item.bed_number,
            bind: 2,
          };
          this.$http({
            url: "/api/hope/assign_beds",
            method: "POST",
            params: data,
            headers: {
              Token: localStorage.getItem("token"),
            },
          }).then((res) => {
            this.$message.success("解绑成功");
            this.fetchData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>
<style scoped>
@import url('../../assets/style/commo.css');

.config_tips {
  color: #e24040;
  margin-bottom: 16px;
  font-size: 18px;
}

.set_config_box {
  font-size: 18px;
  padding: 0 24px;
}

.config_type_title {
  color: #252b50;
  font-weight: bold;
  margin-bottom: 12px;
}

.mt_20 {
  margin-top: 20px;
}

.set_config_box>>>.el_input {
  width: 364px;
}

.set_config_box>>>.el-form-item__label,
.set_config_box>>>.el-form-item__content {
  font-size: 18px;
  line-height: 54px;
}

.el_input_2 {
  width: 430px;
}

/* .config_set_form >>> .el-form-item__error {
  font-size: 0;
}
.config_set_form >>> .el-form-item {
  margin-bottom: 4px;
} */
.table_icon {
  width: 18px;
  margin-right: 4px;
}

.dialog_search_box {
  display: flex;
  justify-content: start;
  margin-bottom: 20px;
}

.dialog_search {
  margin-bottom: 24px;
}

.notice_config_box {
  padding: 60px 120px;
}

.replace_box {
  /* height: 340px; */
  width: 100%;
  padding-top: 120px;
  padding-bottom: 120px;
}

.padding_replace_box {
  padding: 110px 60px 110px;
}

.replace_title {
  text-align: center;
  font-size: 18px;
  color: #252B50;
}

.replace_items {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  position: relative;
}

.replac_input_l {
  margin-left: 30px;
}

.replace_box /deep/ .el-input__inner {
  height: 60px !important;
  font-size: 42px;
  text-align: center;
  line-height: 60px;
  width: 60px;
}

.replace_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  /* background: rgba(0,0,0, 0.5); */
}

.replace_err {
  color: #E24040;
  font-size: 16px;
  margin-top: 24px;
  text-align: center;
}

.replac_input_err /deep/ .el-input__inner {
  border-color: #E24040;
}

.replace_box_text {
  font-size: 18px;
  color: #636676;
  text-align: center;
}

.replace_search {
  height: 300px;
}

.replace_search_list {
  display: flex;
  flex-flow: wrap;
  /* width: 670px; */
  margin-top: 24px;
  height: 100%;
  overflow-y: auto;
}

.replace_search_list_box {
  width: 30%;
  margin-left: 1%;
  padding: 14px;
  font-size: 18px;
}

.block_conten {
  text-align: center;
  margin-top: 15px;
}

.zr {
  font-size: 16px;
  color: #636676;
}

.zr_box_title {
  text-align: center;
  margin-top: 12px;
  font-weight: bold;
}

.zr_box {
  display: flex;
  width: 100%;
  height: 88px;
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.zr_box_l {
  background: #F5F7FB;
  height: 88px;
  width: 144px;
  text-align: center;
}

.zr_box_text {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.zr_box_r {
  width: 198px;
}

._btn {
  margin-bottom: 5px;
  margin-top: 5px;
}

.replace_search>>>.el-input__inner,
.notice_config_box>>>.el-input__inner {
  background-color: #F5F7FB !important;
  border: unset !important;
  height: 54px !important;
  font-size: 18px !important;
}

.notice_config_box>>>.el-range-input {
  background-color: #F5F7FB !important;
}

.notice_config_box>>>.el-range-input::placeholder {
  color: #929FAF !important;
}

.notice_config_box>>>.el-form-item__label {
  line-height: 54px !important;
}

.notice_config_box>>>.el-switch {
  height: 54px;
}

.container>>>.el_table,
.container>>>.el-pagination li,
.container>>>.el-pagination div,
.container>>>.el-pagination span,
.container>>>.el-pagination input {
  font-size: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/device_manage.vue